/**
 * Session Browser Feature Module
 *
 * Registers the session-browser workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the session-browser workspace component
registerWorkspaceComponent(
  'session-browser',
  lazyWorkspaceTab(() => import('./components/SessionBrowserTab').then((m) => ({ default: m.SessionBrowserTab }))),
);

// Re-export components
